module.exports = __webpack_public_path__ + "static/img/szafa_42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_42.svg
// module id = Pe18
// module chunks = 0